export default __webpack_public_path__ + "static/media/downie.b8f3fe27.png";